import { useQuery } from "@tanstack/react-query";

import type { ApiClient } from "../client";
import { useApiClient } from "../useApiClient";

import {
  ANALYTICS_QUERY_KEY,
  toAnalyticsQuery,
  type AnalyticsFilters,
} from "./useSummary";

export function pnlByDayQueryOptions(
  client: ApiClient,
  filters: AnalyticsFilters = {},
) {
  return {
    queryKey: [...ANALYTICS_QUERY_KEY, "pnl-by-day", filters],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/analytics/pnl-by-day", {
        params: { query: toAnalyticsQuery(filters) },
      });
      if (error !== undefined) {
        throw new Error("Failed to load daily P&L");
      }
      return data;
    },
  };
}

export function usePnLByDay(filters: AnalyticsFilters = {}) {
  const client = useApiClient();
  return useQuery(pnlByDayQueryOptions(client, filters));
}
